export class ListGcpSubnetsResponse {
    'subnets';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "subnets",
            "baseName": "subnets",
            "type": "Array<GcpSubnet>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListGcpSubnetsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
